import { render, staticRenderFns } from "./EhsCard.vue?vue&type=template&id=827b2bfa"
import script from "./EhsCard.vue?vue&type=script&lang=js"
export * from "./EhsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports